module.exports = __webpack_public_path__ + "img/resource-tech-image-02.78430b5b.jpg";